import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Paper,
  Stack,
  Fade,
  Zoom,
  Slide,
} from "@mui/material";
// import { Home, ArrowBack, Search, ErrorOutline } from "@mui/icons-material";
import logo from "../../Assets/logo.png";
import { MyArrowBackIcon, MyHomeIcon} from "../../Assets/svg/MyIcons";

const NotFoundPage = () => {
  const [visible, setVisible] = useState(false);
  const [glitchActive, setGlitchActive] = useState(false);

  useEffect(() => {
    setVisible(true);

    // Glitch effect every 3 seconds
    const glitchInterval = setInterval(() => {
      setGlitchActive(true);
      setTimeout(() => setGlitchActive(false), 200);
    }, 3000);

    return () => clearInterval(glitchInterval);
  }, []);

  const navigate = () => {
    window.location.href = "/dashboard";
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%)",
          animation: "float 6s ease-in-out infinite",
        },
        "@keyframes float": {
          "0%, 100%": { transform: "translateY(0px)" },
          "50%": { transform: "translateY(-20px)" },
        },
      }}
    >
      {/* Floating particles */}
      {[...Array(8)].map((_, i) => (
        <Box
          key={i}
          sx={{
            position: "absolute",
            width: Math.random() * 20 + 10,
            height: Math.random() * 20 + 10,
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.1)",
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animation: `particle${i} ${
              Math.random() * 10 + 5
            }s linear infinite`,
            "@keyframes particle0": {
              "0%": { transform: "translateY(0px) rotate(0deg)" },
              "100%": { transform: "translateY(-100vh) rotate(360deg)" },
            },
            "@keyframes particle1": {
              "0%": { transform: "translateY(0px) rotate(0deg)" },
              "100%": { transform: "translateY(-100vh) rotate(-360deg)" },
            },
            "@keyframes particle2": {
              "0%": { transform: "translateY(0px) rotate(0deg)" },
              "100%": { transform: "translateY(-100vh) rotate(180deg)" },
            },
            "@keyframes particle3": {
              "0%": { transform: "translateY(0px) rotate(0deg)" },
              "100%": { transform: "translateY(-100vh) rotate(-180deg)" },
            },
            "@keyframes particle4": {
              "0%": { transform: "translateY(0px) rotate(0deg)" },
              "100%": { transform: "translateY(-100vh) rotate(360deg)" },
            },
            "@keyframes particle5": {
              "0%": { transform: "translateY(0px) rotate(0deg)" },
              "100%": { transform: "translateY(-100vh) rotate(-360deg)" },
            },
            "@keyframes particle6": {
              "0%": { transform: "translateY(0px) rotate(0deg)" },
              "100%": { transform: "translateY(-100vh) rotate(180deg)" },
            },
            "@keyframes particle7": {
              "0%": { transform: "translateY(0px) rotate(0deg)" },
              "100%": { transform: "translateY(-100vh) rotate(-180deg)" },
            },
          }}
        />
      ))}

      <Container maxWidth="md">
        <Fade in={visible} timeout={800}>
          <Paper
            elevation={20}
            sx={{
              background: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(20px)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "24px",
              padding: { xs: "40px 20px", sm: "60px 40px" },
              textAlign: "center",
              position: "relative",
              overflow: "hidden",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-100%",
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(90deg, transparent, rgba(34, 65, 158, 0.1), transparent)",
                animation: "shimmer 3s infinite",
              },
              "@keyframes shimmer": {
                "0%": { left: "-100%" },
                "100%": { left: "100%" },
              },
            }}
          >
            {/* Logo */}
            <Slide direction="down" in={visible} timeout={1000}>
              <Box sx={{ marginBottom: "60px" }}>
                <img
                  src={`${logo}`}
                  alt="logo"
                  style={{
                    width: "220px",
                    height: "auto",
                    filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.1))",
                  }}
                />
              </Box>
            </Slide>

            {/* 404 Error Display with Glitch Effect */}
            <Zoom in={visible} timeout={1200}>
              <Box
                sx={{
                  marginBottom: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    background: "linear-gradient(135deg, #22419E, #4A90E2)",
                    borderRadius: "50%",
                    width: { xs: "180px", sm: "240px" },
                    height: { xs: "180px", sm: "240px" },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    boxShadow: "0 20px 40px rgba(34, 65, 158, 0.3)",
                    animation: "pulse 2s infinite",
                    "@keyframes pulse": {
                      "0%": {
                        transform: "scale(1)",
                        boxShadow: "0 20px 40px rgba(34, 65, 158, 0.3)",
                      },
                      "50%": {
                        transform: "scale(1.05)",
                        boxShadow: "0 25px 50px rgba(34, 65, 158, 0.4)",
                      },
                      "100%": {
                        transform: "scale(1)",
                        boxShadow: "0 20px 40px rgba(34, 65, 158, 0.3)",
                      },
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "3.5rem", sm: "5rem" },
                      fontWeight: "900",
                      color: "white",
                      fontFamily: "monospace",
                      textShadow: "0 4px 8px rgba(0,0,0,0.3)",
                      ...(glitchActive && {
                        animation: "glitch 0.2s infinite",
                        "@keyframes glitch": {
                          "0%": { transform: "translate(0)" },
                          "20%": { transform: "translate(-2px, 2px)" },
                          "40%": { transform: "translate(-2px, -2px)" },
                          "60%": { transform: "translate(2px, 2px)" },
                          "80%": { transform: "translate(2px, -2px)" },
                          "100%": { transform: "translate(0)" },
                        },
                      }),
                    }}
                  >
                    404
                  </Typography>
                </Box>

                {/* Rotating ring */}
                <Box
                  sx={{
                    position: "absolute",
                    width: { xs: "220px", sm: "280px" },
                    height: { xs: "220px", sm: "280px" },
                    border: "3px solid rgba(34, 65, 158, 0.2)",
                    borderRadius: "50%",
                    borderTopColor: "#22419E",
                    animation: "spin 3s linear infinite",
                    "@keyframes spin": {
                      "0%": { transform: "rotate(0deg)" },
                      "100%": { transform: "rotate(360deg)" },
                    },
                  }}
                />
              </Box>
            </Zoom>

            {/* Error Icon */}
            {/* <Slide direction="up" in={visible} timeout={1000}>
              <Box sx={{ marginBottom: "20px" }}>
                <ErrorOutline
                  sx={{
                    fontSize: "3rem",
                    color: "#22419E",
                    animation: "bounce 2s infinite",
                    "@keyframes bounce": {
                      "0%, 20%, 50%, 80%, 100%": { transform: "translateY(0)" },
                      "40%": { transform: "translateY(-10px)" },
                      "60%": { transform: "translateY(-5px)" },
                    },
                  }}
                />
              </Box>
            </Slide> */}

            {/* Title */}
            <Slide direction="left" in={visible} timeout={1400}>
              <Typography
                variant="h3"
                component="h1"
                sx={{
                  fontSize: { xs: "2rem", sm: "2.5rem" },
                  fontWeight: "800",
                  background: "linear-gradient(45deg, #22419E, #4A90E2)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  margin: "60px 0 15px 0",
                  lineHeight: "1.2",
                  animation: "slideInLeft 0.8s ease-out",
                  "@keyframes slideInLeft": {
                    "0%": { transform: "translateX(-50px)", opacity: 0 },
                    "100%": { transform: "translateX(0)", opacity: 1 },
                  },
                }}
              >
                Oops!! Page Not Found
              </Typography>
            </Slide>

            {/* Subtitle */}
            <Slide direction="right" in={visible} timeout={1600}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.1rem",
                  color: "#64748b",
                  margin: "0 0 40px 0",
                  lineHeight: "1.6",
                  maxWidth: "500px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  animation: "slideInRight 0.8s ease-out",
                  "@keyframes slideInRight": {
                    "0%": { transform: "translateX(50px)", opacity: 0 },
                    "100%": { transform: "translateX(0)", opacity: 1 },
                  },
                }}
              >
                The page you are looking for cannot be found or an error
                occurred.
                <br />
                Don't worry, let's get you back on track!
              </Typography>
            </Slide>

            {/* Action Buttons */}
            <Slide direction="up" in={visible} timeout={1800}>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                justifyContent="center"
                alignItems="center"
                sx={{
                  "& .MuiButton-root": {
                    minWidth: { xs: "280px", sm: "180px" },
                    textTransform: "none",
                    fontSize: "1.1rem",
                    fontWeight: "600",
                    padding: "14px 28px",
                    borderRadius: "50px",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    position: "relative",
                    overflow: "hidden",
                  },
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<MyHomeIcon />}
                  onClick={navigate}
                  sx={{
                    background: "linear-gradient(45deg, #22419E, #4A90E2)",
                    color: "white",
                    boxShadow: "0 8px 25px rgba(34, 65, 158, 0.4)",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: "-100%",
                      width: "100%",
                      height: "100%",
                      background:
                        "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)",
                      transition: "left 0.5s",
                    },
                    "&:hover": {
                      transform: "translateY(-3px) scale(1.02)",
                      boxShadow: "0 12px 35px rgba(34, 65, 158, 0.5)",
                      "&::before": {
                        left: "100%",
                      },
                    },
                    "&:active": {
                      transform: "translateY(-1px) scale(0.98)",
                    },
                  }}
                >
                  Go To Dashboard
                </Button>

                <Button
                  variant="outlined"
                  startIcon={<MyArrowBackIcon />}
                  onClick={handleGoBack}
                  sx={{
                    backgroundColor: "transparent",
                    color: "#22419E",
                    border: "2px solid #22419E",
                    "&:hover": {
                      backgroundColor: "#22419E",
                      color: "white",
                      transform: "translateY(-3px) scale(1.02)",
                      boxShadow: "0 8px 25px rgba(34, 65, 158, 0.3)",
                      border: "2px solid #22419E",
                    },
                    "&:active": {
                      transform: "translateY(-1px) scale(0.98)",
                    },
                  }}
                >
                  Go Back
                </Button>
              </Stack>
            </Slide>

            {/* Search Icon Decoration */}
            {/* <Box
              sx={{
                position: "absolute",
                top: "20px",
                right: "20px",
                opacity: 0.1,
                animation: "float 4s ease-in-out infinite",
              }}
            >
              <MySearchIcon sx={{ fontSize: "3rem", color: "#22419E" }} />
            </Box> */}
          </Paper>
        </Fade>
      </Container>
    </Box>
  );
};

export default NotFoundPage;
